/**
 * Axios 请求参数自动 trim 插件
 *
 * 使用方式：
 *   trimPlugin(axiosInstance)
 *
 * 忽略特定字段：
 *   axios.post(url, data, { trimIgnore: ['data.password', 'data.content'] })
 */
export default function trimPlugin(axiosInstance) {
  axiosInstance.interceptors.request.use((config) => {
    const ignorePaths = config.trimIgnore || []

    /* eslint-disable no-param-reassign */
    if (config.data) {
      config.data = deepTrim(config.data, ignorePaths, 'data')
    }
    if (config.params) {
      config.params = deepTrim(config.params, ignorePaths, 'params')
    }
    /* eslint-enable no-param-reassign */

    return config
  })
}

function isPlainObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}

function deepTrim(obj, ignorePaths, prefix) {
  if (typeof obj === 'string') {
    return obj.trim()
  }

  if (Array.isArray(obj)) {
    return obj.map((item, index) =>
      deepTrim(item, ignorePaths, `${prefix}[${index}]`))
  }

  // 只处理纯对象，跳过 FormData、Date、File、Blob 等特殊对象
  if (isPlainObject(obj)) {
    const newObj = {}
    Object.keys(obj).forEach((key) => {
      const path = `${prefix}.${key}`
      if (ignorePaths.includes(path)) {
        newObj[key] = obj[key]
      } else {
        newObj[key] = deepTrim(obj[key], ignorePaths, path)
      }
    })
    return newObj
  }

  return obj
}
